import { useOffersContext } from '@/context/useOffersContext'
import { useSelections } from '@/hooks'
import { useSetOfferPaymentFrequency } from '@/hooks/useOffer'
import { Text } from '@chakra-ui/react'
import type { OfferPackage } from 'BrokerTsLib/src/dtos'
import { SelectionType } from 'BrokerTsLib/src/enums'
import { priceFormat } from 'BrokerTsLib/src/Utils/formatPrice'
import { useState } from 'react'
import { OfferCellWrapper } from './OfferCellWrapper'
import { TinySelect } from './TinySelect'

export type OfferCellPaymentProps = {
  offerId: number
  isDisabled?: boolean
}

export const OfferCellPayment = ({ offerId, isDisabled }: OfferCellPaymentProps) => {
  const { recalculateOffers: recalculate, offers: o } = useOffersContext()
  const offers = o as OfferPackage[]
  const { mutateAsync: updatePf } = useSetOfferPaymentFrequency()

  const offer = offers!.find(x => x.offerId == offerId)

  const { data: pfData } = useSelections(SelectionType.FrekvencePlatby)
  const pf = pfData?.data ?? []

  // aby se zmena projevila na UI hned a ne az po rekalkulaci
  const [paymentFrequencyId, setPaymentFrequencyId] = useState(offer?.paymentFrequencyId)

  const handleEdit = (id: number) => {
    setPaymentFrequencyId(id)
    updatePf({
      offerId: offerId,
      paymentFrequency: id
    }).then(() => {
      recalculate([offerId], true)
        .then((recOffers) => {
          // nektere pojistovny nepodporuji vsechny frekvence plateb
          // je treba upravit nastavenou frekvenci nabidky po rekalkulaci
          if (!recOffers?.data) return
          const recOffer = recOffers.data.find(x => x.offerId == offerId)
          if (recOffer?.paymentFrequencyId) {
            setPaymentFrequencyId(recOffer.paymentFrequencyId)
          }
        })
    })
  }

  return (
    <OfferCellWrapper sx={{ alignItems: 'center', justifyContent: 'space-between' }} riskId='payment'>
      <TinySelect
        isDisabled={isDisabled}
        onChange={(e) => {
          handleEdit(parseInt(e.target.value))
        }}
        value={paymentFrequencyId?.toString() ?? ''}
        sx={{
          borderBottom: 'none',
          fontWeight: 'light',
        }}
      >
        {pf.map(x => { return { id: x.id, value: x.description ?? x.name ?? '' } }).map((option) => {
          if (!option.value || !option.id) return null

          return (
            <option key={option.value} value={option.id.toString()}>
              {option.value}
            </option>
          )
        })}
      </TinySelect>

      <Text sx={{ p: 0, fontSize: 'sm', mr: !isDisabled ? 5 : 0 }}>
        {priceFormat(offer?.priceFrequency)}
      </Text>
    </OfferCellWrapper >
  )
}